import { render, staticRenderFns } from "./navMobile.vue?vue&type=template&id=05c51026&scoped=true&"
import script from "./navMobile.vue?vue&type=script&lang=js&"
export * from "./navMobile.vue?vue&type=script&lang=js&"
import style0 from "./navMobile.vue?vue&type=style&index=0&id=05c51026&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c51026",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavCollapseList: require('D:/Project/kpwebsite/H5/components/nav/navCollapseList.vue').default})
